export const isLoadboardWebView = import.meta.env.VITE_APP_NAME === 'slbm';
export const isCarrierTMSWebView = import.meta.env.VITE_APP_NAME === 'ctmsw';
export const isWebView = isLoadboardWebView || isCarrierTMSWebView;
export const isLoadboardDesktop = import.meta.env.VITE_APP_TYPE === 'slbd';
export const isProduction = import.meta.env.VITE_APP_TARGET === 'production';
